import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const sealsSchema = z
    .union([
    z.literal("plow-doy").describe("Plow Doy"),
    z.literal("plow-k-seal").describe("Plow K Seal"),
    z.literal("plow-k-seal-with-skirt").describe(createCustomSettings({
        dependsOn: {
            field: "requestDetails.pouchType",
            value: ["Stand-Up Pouch"],
        },
        label: "Plow K Seal With Skirt",
    })),
    z.literal("inserted-doy").describe("Inserted Doy"),
    z
        .literal("inserted-k-seal-with-skirt")
        .describe("Inserted K Seal With Skirt"),
    z.literal("3-side").describe(createCustomSettings({
        dependsOn: {
            field: "requestDetails.pouchType",
            value: ["Corner Spout", "Top Spout"],
        },
        label: "3-Side Seal",
    })),
    z.literal("2-side").describe(createCustomSettings({
        dependsOn: {
            field: "requestDetails.pouchType",
            value: ["Corner Spout", "Top Spout"],
        },
        label: "2-Side Seal",
    })),
    z
        .literal("quad")
        .describe(createCustomSettings({ hide: true, label: "Quad Seal" })),
    z
        .literal("fin")
        .describe(createCustomSettings({ hide: true, label: "Fin" })),
    z
        .literal("none")
        .describe(createCustomSettings({ hide: true, label: "None" })),
    z
        .literal("plow-none")
        .describe(createCustomSettings({ hide: true, label: "Plow" })),
    z.literal("other").describe(createCustomSettings({ hide: true })),
    z
        .literal("vffs")
        .describe(createCustomSettings({ hide: true, label: "Vertical Form Fill" })),
    z
        .literal("lap")
        .describe(createCustomSettings({ hide: true, label: "Lap" })),
    z
        .literal("flat-bottom-seal")
        .describe(createCustomSettings({ hide: true, label: "Flat Bottom" })),
])
    .optional()
    .describe(createCustomSettings({
    dependsOn: {
        field: "requestDetails.pouchType",
        value: ["Stand-Up Pouch", "Corner Spout", "Top Spout"],
    },
    label: "Seal Type",
}));
//# sourceMappingURL=seals.js.map